import { ComparisonOperator } from '../enums/ComparisonOperator';

export class RangeDescriptor<T>
{
    public constructor(op: ComparisonOperator, value: T)
    {
        this.operator = op;
        this.value = value;
    }

    public value!: T;

    public operator!: ComparisonOperator;
}